import React, { FC } from 'react';
import { EmptyListStyled } from './EmptyList.styles';

export interface IProps {
  itemHeight?: number;
}

const EmptyList: FC<IProps> = props => {
  const { itemHeight } = props;

  return (
    <EmptyListStyled itemHeight={itemHeight}>
      <div className="empty-item">There are no items to show in this category</div>
    </EmptyListStyled>
  );
};

export default EmptyList;
